import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@node-space/hooks'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getActivity } from 'services/ActivityService'
import { isTestEnvironment, logout } from 'utils/utils'

export const useActivityQuery = (canViewApiKeys = true) => {
  const { isAuthed } = useAuth()

  return useQuery(reactQueryKeys.activity(), () => getActivity(canViewApiKeys), {
    enabled: isTestEnvironment || !!isAuthed,
    onError: (error: unknown) => {
      logSentryError('Error: useActivityQuery', error)
      logout()
    },
  })
}
